"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from "react";
import { Tooltip } from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAddressCard, faStar } from "@fortawesome/free-regular-svg-icons";
import { faAward } from "@fortawesome/free-solid-svg-icons";
import { ApiWave } from "@/generated/models/ApiWave";
import { ApiWaveOutcomeCredit } from "@/generated/models/ApiWaveOutcomeCredit";
import { ApiWaveOutcomeType } from "@/generated/models/ApiWaveOutcomeType";
import { ApiDrop } from "@/generated/models/ApiDrop";
interface WaveSmallLeaderboardItemOutcomesProps {
  readonly drop: ApiDrop;
  readonly wave: ApiWave;
  readonly isMobile?: boolean;
}
interface OutcomeSummary {
  nicTotal: number;
  repTotal: number;
  manualOutcomes: string[];
}
const calculateNIC = ({
  drop,
  wave
}: {
  drop: ApiDrop;
  wave: ApiWave;
}): number => {
  const rank = drop.rank;
  if (!rank) return 0;
  const outcomes = wave.outcomes;
  const nicOutcomes = outcomes.filter(outcome => outcome.credit === ApiWaveOutcomeCredit.Cic);
  const nic = nicOutcomes.reduce((acc, outcome) => {
    return acc + (outcome.distribution?.[rank - 1]?.amount ?? 0);
  }, 0);
  return nic;
};
const calculateRep = ({
  drop,
  wave
}: {
  drop: ApiDrop;
  wave: ApiWave;
}): number => {
  const rank = drop.rank;
  if (!rank) return 0;
  const outcomes = wave.outcomes;
  const repOutcomes = outcomes.filter(outcome => outcome.credit === ApiWaveOutcomeCredit.Rep);
  const rep = repOutcomes.reduce((acc, outcome) => {
    return acc + (outcome.distribution?.[rank - 1]?.amount ?? 0);
  }, 0);
  return rep;
};
const calculateManualOutcomes = ({
  drop,
  wave
}: {
  drop: ApiDrop;
  wave: ApiWave;
}): string[] => {
  const rank = drop.rank;
  if (!rank) return [];
  const outcomes = wave.outcomes;
  const manualOutcomes = outcomes.filter(outcome => outcome.type === ApiWaveOutcomeType.Manual);
  return manualOutcomes.filter(outcome => !!outcome.distribution?.[rank - 1]?.amount).map(outcome => outcome.distribution?.[rank - 1]?.description ?? "");
};
const calculateOutcomeSummary = ({
  drop,
  wave
}: {
  drop: ApiDrop;
  wave: ApiWave;
}): OutcomeSummary => {
  return {
    nicTotal: calculateNIC({
      drop,
      wave
    }),
    repTotal: calculateRep({
      drop,
      wave
    }),
    manualOutcomes: calculateManualOutcomes({
      drop,
      wave
    })
  };
};
export const WaveSmallLeaderboardItemOutcomes: React.FC<WaveSmallLeaderboardItemOutcomesProps> = t0 => {
  const $ = _c(61);
  const {
    drop,
    wave,
    isMobile: t1
  } = t0;
  const isMobile = t1 === undefined ? false : t1;
  const [isTouch, setIsTouch] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsTouch("ontouchstart" in window);
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  let t4;
  if ($[2] !== isOpen || $[3] !== isTouch) {
    t4 = e => {
      if (isTouch) {
        e.stopPropagation();
        setIsOpen(!isOpen);
      }
    };
    $[2] = isOpen;
    $[3] = isTouch;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleClick = t4;
  let manualOutcomes;
  let nicTotal;
  let repTotal;
  let t10;
  let t11;
  let t12;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] !== drop || $[6] !== wave) {
    t12 = Symbol.for("react.early_return_sentinel");
    bb0: {
      ({
        nicTotal,
        repTotal,
        manualOutcomes
      } = calculateOutcomeSummary({
        drop,
        wave
      }));
      const totalOutcomes = (nicTotal ? 1 : 0) + (repTotal ? 1 : 0) + manualOutcomes.length;
      if (totalOutcomes === 0) {
        t12 = null;
        break bb0;
      }
      t11 = "tw-p-3 tw-space-y-3 tw-min-w-[200px]";
      t9 = "tw-space-y-2";
      if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = <span className="tw-text-xs tw-font-medium tw-text-iron-400">Outcome</span>;
        $[18] = t10;
      } else {
        t10 = $[18];
      }
      t5 = "tw-space-y-1.5";
      t6 = !!nicTotal && <div className="tw-flex tw-items-center tw-justify-between"><div className="tw-flex tw-items-center tw-gap-2"><FontAwesomeIcon icon={faAddressCard} className="tw-size-4 tw-text-blue-300/70" /><span className="tw-text-xs tw-font-medium tw-text-iron-300">NIC</span></div><span className="tw-text-xs tw-font-medium tw-text-blue-200/90">{nicTotal}</span></div>;
      t7 = !!repTotal && <div className="tw-flex tw-items-center tw-justify-between"><div className="tw-flex tw-items-center tw-gap-2"><FontAwesomeIcon icon={faStar} className="tw-size-4 tw-text-purple-300/70" /><span className="tw-text-xs tw-font-medium tw-text-iron-300">Rep</span></div><span className="tw-text-xs tw-font-medium tw-text-purple-200/90">{repTotal}</span></div>;
      t8 = manualOutcomes.map(_temp);
    }
    $[5] = drop;
    $[6] = wave;
    $[7] = manualOutcomes;
    $[8] = nicTotal;
    $[9] = repTotal;
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    manualOutcomes = $[7];
    nicTotal = $[8];
    repTotal = $[9];
    t10 = $[10];
    t11 = $[11];
    t12 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
    t9 = $[17];
  }
  if (t12 !== Symbol.for("react.early_return_sentinel")) {
    return t12;
  }
  let t13;
  if ($[19] !== t5 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
    t13 = <div className={t5}>{t6}{t7}{t8}</div>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t10 || $[25] !== t13 || $[26] !== t9) {
    t14 = <div className={t9}>{t10}{t13}</div>;
    $[24] = t10;
    $[25] = t13;
    $[26] = t9;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t11 || $[29] !== t14) {
    t15 = <div className={t11}>{t14}</div>;
    $[28] = t11;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  const tooltipContent = t15;
  const t16 = `tw-border-0 tw-rounded-lg tw-flex tw-items-center ${isMobile ? "tw-gap-4" : "tw-gap-2"} tw-min-w-6 tw-py-1.5 tw-px-2 tw-bg-iron-800 tw-ring-1 tw-ring-iron-700 ${isTouch ? "tw-cursor-pointer" : ""}`;
  const t17 = `wave-outcomes-${drop.id}`;
  let t18;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <span className="tw-text-xs tw-font-medium tw-text-iron-200">Outcome:</span>;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== nicTotal) {
    t19 = !!nicTotal && <FontAwesomeIcon icon={faAddressCard} className="tw-size-4 tw-text-blue-300/70 tw-flex-shrink-0" />;
    $[32] = nicTotal;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== repTotal) {
    t20 = !!repTotal && <FontAwesomeIcon icon={faStar} className="tw-size-4 tw-text-purple-300/70 tw-flex-shrink-0" />;
    $[34] = repTotal;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== manualOutcomes.length) {
    t21 = manualOutcomes.length > 0 && <FontAwesomeIcon icon={faAward} className="tw-size-4 tw-text-amber-300/70 tw-flex-shrink-0" />;
    $[36] = manualOutcomes.length;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t19 || $[39] !== t20 || $[40] !== t21) {
    t22 = <div className="tw-flex tw-items-center tw-gap-2">{t19}{t20}{t21}</div>;
    $[38] = t19;
    $[39] = t20;
    $[40] = t21;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== handleClick || $[43] !== t16 || $[44] !== t17 || $[45] !== t22) {
    t23 = <button onClick={handleClick} className={t16} data-tooltip-id={t17}>{t18}{t22}</button>;
    $[42] = handleClick;
    $[43] = t16;
    $[44] = t17;
    $[45] = t22;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  const t24 = `wave-outcomes-${drop.id}`;
  let t25;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px",
      zIndex: 10
    };
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  let t27;
  let t28;
  if ($[48] !== isTouch) {
    t26 = isTouch ? {
      click: true
    } : {
      mouseenter: true
    };
    t27 = isTouch ? {
      click: true
    } : {
      mouseleave: true
    };
    t28 = isTouch ? {
      clickOutsideAnchor: true
    } : {};
    $[48] = isTouch;
    $[49] = t26;
    $[50] = t27;
    $[51] = t28;
  } else {
    t26 = $[49];
    t27 = $[50];
    t28 = $[51];
  }
  let t29;
  if ($[52] !== t24 || $[53] !== t26 || $[54] !== t27 || $[55] !== t28 || $[56] !== tooltipContent) {
    t29 = <Tooltip id={t24} place="top" style={t25} clickable={true} openEvents={t26} closeEvents={t27} globalCloseEvents={t28}>{tooltipContent}</Tooltip>;
    $[52] = t24;
    $[53] = t26;
    $[54] = t27;
    $[55] = t28;
    $[56] = tooltipContent;
    $[57] = t29;
  } else {
    t29 = $[57];
  }
  let t30;
  if ($[58] !== t23 || $[59] !== t29) {
    t30 = <>{t23}{t29}</>;
    $[58] = t23;
    $[59] = t29;
    $[60] = t30;
  } else {
    t30 = $[60];
  }
  return t30;
};
function _temp(outcome) {
  return <div key={outcome} className="tw-flex tw-items-center tw-justify-between"><div className="tw-flex tw-items-center tw-gap-2"><FontAwesomeIcon icon={faAward} className="tw-size-4 tw-text-amber-300/70" /><span className="tw-text-xs tw-font-medium tw-text-amber-100/90">{outcome}</span></div></div>;
}